import { Button } from '@/components/ui/button';
import { useEditMode } from '@/contexts/EditModeContext';
import { Pencil, PencilOff } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function EditModeToggle() {
  const { isEditMode, toggleEditMode } = useEditMode();
  const [isDemoUser, setIsDemoUser] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setIsDemoUser(user?.email === 'support@therappi.app');
    };
    checkUser();
  }, []);

  // Hide edit controls for demo user
  if (isDemoUser) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={isEditMode ? 'default' : 'outline'}
          size="sm"
          onClick={toggleEditMode}
          className="gap-2"
        >
          {isEditMode ? (
            <>
              <PencilOff className="h-4 w-4" />
              <span className="hidden sm:inline">Exit Edit Mode</span>
            </>
          ) : (
            <>
              <Pencil className="h-4 w-4" />
              <span className="hidden sm:inline">Edit Content</span>
            </>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {isEditMode 
          ? 'Exit edit mode' 
          : 'Click to edit any text directly on the page'}
      </TooltipContent>
    </Tooltip>
  );
}
